export var ZeroEtlRoutingMode;
(function (ZeroEtlRoutingMode) {
    ZeroEtlRoutingMode["ZERO_ETL_ROUTING_MODE_FULLY_QUALIFIED"] = "FULLY_QUALIFIED";
    ZeroEtlRoutingMode["ZERO_ETL_ROUTING_MODE_MANUAL"] = "MANUAL";
})(ZeroEtlRoutingMode || (ZeroEtlRoutingMode = {}));
